import { curry2 } from '@most/prelude';
export var complete = curry2(function complete(value, subject) {
    return subject.complete(value);
});
//# sourceMappingURL=complete.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/most-subject/lib/es2015/combinators/complete.js
// module id = 865
// module chunks = 0